"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMobileCommunicatorMockMode = exports.setMobileCommunicatorMockMode = void 0;
const store_1 = require("../../store");
const store = (0, store_1.getDefaultLocalStore)();
const STORE_KEY = 'MobileCommunicatorMock';
const setMobileCommunicatorMockMode = (value) => {
    store.setItem(STORE_KEY, value);
};
exports.setMobileCommunicatorMockMode = setMobileCommunicatorMockMode;
const isMobileCommunicatorMockMode = () => {
    return !!store.getItem(STORE_KEY);
};
exports.isMobileCommunicatorMockMode = isMobileCommunicatorMockMode;
//# sourceMappingURL=developmentMobileCommunicatorUtils.js.map